import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/img/icon/copy.svg'
import _imports_1 from '@/assets/img/icon/delete.svg'


const _hoisted_1 = { class: "flex justify-between items-center mb-3" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "flex w-full mb-2" }
const _hoisted_5 = { class: "w-3/4" }
const _hoisted_6 = { class: "flex w-full " }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Belaku Mulai")
], -1)
const _hoisted_8 = { class: "w-5/6" }
const _hoisted_9 = { class: "font-bold text-subtitle1" }
const _hoisted_10 = { class: "flex w-full mb-2" }
const _hoisted_11 = { class: "w-3/4" }
const _hoisted_12 = { class: "flex w-full " }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Perubahan Harga")
], -1)
const _hoisted_14 = { class: "w-5/6" }
const _hoisted_15 = {
  key: 0,
  class: "font-bold color-primary"
}
const _hoisted_16 = { class: "flex w-full" }
const _hoisted_17 = { class: "w-3/4" }
const _hoisted_18 = { class: "flex w-full " }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, [
  /*#__PURE__*/_createVNode("p", { class: "color-blue-grey-lighten-1 text-subtitle1" }, "Tipe Barang")
], -1)
const _hoisted_20 = { class: "w-5/6" }
const _hoisted_21 = { class: "font-bold text-subtitle1" }
const _hoisted_22 = { class: "w-1/4" }
const _hoisted_23 = { class: "flex w-full justify-end" }
const _hoisted_24 = { class: "color-blue-grey-lighten-1" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Versi Revisi ")
const _hoisted_26 = { class: "text-black" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex items-center justify-between title-section" }
const _hoisted_29 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Perubahan Harga", -1)
const _hoisted_30 = { class: "list-items py-4" }
const _hoisted_31 = { class: "flex items-center justify-between px-5 pt-3 pb-1" }
const _hoisted_32 = { class: "font-bold text-black" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = {
  key: 0,
  class: "color-green mr-3 text-sm"
}
const _hoisted_35 = {
  key: 1,
  class: "color-red mr-3 text-sm"
}
const _hoisted_36 = { class: "flex items-center px-5 pb-3" }
const _hoisted_37 = { class: "text-subtitle2 color-blue-grey" }
const _hoisted_38 = { class: "flex items-center justify-between title-section mb-3" }
const _hoisted_39 = {
  key: 0,
  class: "mr-3 font-normal"
}
const _hoisted_40 = {
  key: 0,
  class: "flex items-center mb-6"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus w-5 h-5 p-0 m-0 text-center" }, null, -1)
const _hoisted_42 = { class: "flex w-full content-start overflow-x-scroll container-kategori-scroll" }
const _hoisted_43 = { class: "text-center" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_45 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_46 = { class: "flex" }
const _hoisted_47 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mr-2 w-4 h-4",
  alt: "copy"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("p", { class: "font-normal text-base color-blue-grey-darken-1" }, "Duplikat", -1)
const _hoisted_49 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "mr-2 w-4 h-4",
  alt: "del"
}, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("p", { class: "font-normal text-base color-red" }, "Hapus", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-base color-blue-grey-lighten-3" }, "Simpan", -1)
const _hoisted_52 = { class: "w-full" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", {
  id: "spreadsheet",
  class: "excel-clone price"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_PriceForm = _resolveComponent("PriceForm")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_PriceFormItems = _resolveComponent("PriceFormItems")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, { class: "card-item-category mb-4 px-3" }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.data.Code), 1),
          (_ctx.checkPermission(_ctx.PermissionEnum.UpdatePrice) || _ctx.route.meta.permission.write || _ctx.route.meta.permission.delete)
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "pi pi-ellipsis-h text-2xl cursor-pointer text-black",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropDownCategory($event, _ctx.data))),
                "aria:haspopup": "true"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode("div", _hoisted_8, [
                  _createVNode("p", _hoisted_9, _toDisplayString(_ctx.moment(_ctx.data.EffectiveDate).format('DD MMM YYYY')), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, [
                  (_ctx.dataBaseId)
                    ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(_ctx.dataBaseId.Code), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode("div", _hoisted_20, [
                  _createVNode("p", _hoisted_21, _toDisplayString((_ctx.data.GoodCategories) ? _ctx.data.GoodCategories.map(val =>
            val.GoodCategoryName).join() : ''), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("p", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("b", _hoisted_26, _toDisplayString(_ctx.data.Version), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_27, [
      _createVNode(_component_Card, { class: "lg:w-1/3 md:w-1/3 card-price-items sm:w-full mr-2" }, {
        content: _withCtx(() => [
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah",
                  icon: "pi pi-plus",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addPerubahanHarga(_ctx.currentHarga))),
                  class: "font-semibold p-button-sm btn-primary text-sm"
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("ul", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataPerubahan, (item, index) => {
                return (_openBlock(), _createBlock("li", {
                  key: index,
                  class: _ctx.classItemPerubahan(item)
                }, [
                  _createVNode("div", _hoisted_31, [
                    _createVNode("div", {
                      class: "flex items-center cursor-pointer",
                      onClick: ($event: any) => (_ctx.changeBasisId(item))
                    }, [
                      _createVNode("p", _hoisted_32, _toDisplayString(item.Code), 1)
                    ], 8, ["onClick"]),
                    _createVNode("div", _hoisted_33, [
                      (item.IsActive)
                        ? (_openBlock(), _createBlock("p", _hoisted_34, "Aktif"))
                        : (_openBlock(), _createBlock("p", _hoisted_35, "Non Aktif")),
                      (_ctx.route.meta.permission.write || _ctx.route.meta.permission.delete)
                        ? (_openBlock(), _createBlock("i", {
                            key: 2,
                            class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                            onClick: ($event: any) => (_ctx.showDropDown($event, item)),
                            "aria:haspopup": "true"
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _createVNode("p", _hoisted_37, _toDisplayString(_ctx.moment(item.CreatedAt).format('DD MMM YYYY')), 1)
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, { class: "lg:w-2/3 md:w-2/3 sm:w-full ml-2 card-table-price" }, {
        content: _withCtx(() => [
          _createVNode("div", _hoisted_38, [
            (_ctx.dataBaseId)
              ? (_openBlock(), _createBlock("h6", _hoisted_39, _toDisplayString(_ctx.dataBaseId.Kode), 1))
              : _createCommentVNode("", true)
          ]),
          (_ctx.dataPerubahan.length > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_40, [
                _createVNode("div", {
                  class: "chip-orange flex justify-center p-1 cursor-pointer mr-3 items-center",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFormAddItems()))
                }, [
                  _hoisted_41
                ]),
                _createVNode("div", _hoisted_42, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.GoodCategories, (data, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: ["flex justify-center p-1 cursor-pointer mr-3 px-2 flex-grow", _ctx.classItemMenu(data)],
                      key: data.Id,
                      onClick: ($event: any) => (_ctx.changeItemsId(index, data)),
                      style: {"border-radius":"6px"}
                    }, [
                      _createVNode("p", _hoisted_43, _toDisplayString(data.GoodCategoryName), 1)
                    ], 10, ["onClick"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Card, { class: "card-no-shadow" }, {
            title: _withCtx(() => [
              (_ctx.detailItem)
                ? (_openBlock(), _createBlock("div", _hoisted_44, [
                    (_ctx.titleHeaderTable.Code)
                      ? (_openBlock(), _createBlock("p", _hoisted_45, _toDisplayString(_ctx.titleHeaderTable.Name) + " (" + _toDisplayString(_ctx.titleHeaderTable.Code) + ")", 1))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_46, [
                      (_ctx.route.meta.permission.write)
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "flex items-center mr-4 cursor-pointer",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFormEditItems(_ctx.currentCategoryDrop)))
                          }, [
                            _hoisted_47,
                            _hoisted_48
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.route.meta.permission.delete)
                        ? (_openBlock(), _createBlock("div", {
                            key: 1,
                            class: "flex items-center cursor-pointer mr-4",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteCategory()))
                          }, [
                            _hoisted_49,
                            _hoisted_50
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.route.meta.permission.update)
                        ? (_openBlock(), _createBlock("div", {
                            key: 2,
                            class: "flex items-center cursor-pointer",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitDataExcel()))
                          }, [
                            _hoisted_51
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            content: _withCtx(() => [
              _withDirectives(_createVNode("div", _hoisted_52, [
                _hoisted_53
              ], 512), [
                [_vShow, _ctx.detailItem]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_OverlayPanel, { ref: "refEditPrice" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          edit: _ctx.route.meta.permission.update,
          onEdit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectEdit(_ctx.currentHarga))),
          del: _ctx.route.meta.permission.delete,
          onDel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.deleteData(_ctx.currentHarga))),
          add: _ctx.route.meta.permission.write,
          onAdd: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addPrice(_ctx.currentHarga)))
        }, null, 8, ["edit", "del", "add"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, { ref: "refEditHeaderPrice" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          edit: _ctx.checkPermission(_ctx.PermissionEnum.UpdatePrice),
          onEdit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editHeader())),
          del: _ctx.route.meta.permission.delete,
          onDel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.deleteHeader())),
          copy: _ctx.route.meta.permission.write,
          onCopy: _cache[12] || (_cache[12] = ($event: any) => (_ctx.duplicatePrice()))
        }, null, 8, ["edit", "del", "copy"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PriceForm, {
          onCopy: _ctx.onCopy,
          fromId: _ctx.fromIdPrice,
          dataEdit: _ctx.currentHarga,
          onReloadData: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getAll())),
          onCloseSidebar: _ctx.closeSidebar
        }, null, 8, ["onCopy", "fromId", "dataEdit", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActiveItems,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (_ctx.sliderActiveItems = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PriceFormItems, {
          data: _ctx.dataDetailPerubahan,
          fromItemsId: _ctx.currentCategoryDrop,
          catId: _ctx.currentCategoryId,
          onReloadData: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getAllData())),
          onCloseSidebar: _ctx.closeSidebarItems
        }, null, 8, ["data", "fromItemsId", "catId", "onCloseSidebar"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}